import React, { useContext } from 'react';
import { Controller } from 'react-hook-form';
import { StackShim as Stack } from '@fluentui/react-migration-v8-v9';
import { Field, Textarea, FluentProvider, webLightTheme } from '@fluentui/react-components';
import MonthDayPicker from '../../../common/formFields/monthDayPicker/MonthDayPicker';
import hasAccess from '../../../../utils/authorization/authorizationCheck';
import { IAgmStatusDueDateAndInfoFormProps } from './IAgmStatusFormProps';
import { StatUser } from '../../../../utils/statApi/UsersApi';
import UserContext from '../../../../utils/authorization/UserContext';

const AgmStatusDueDateAndInfoForm = ({
  agmStatus,
  form,
}: IAgmStatusDueDateAndInfoFormProps): JSX.Element => {
  const user: StatUser = useContext(UserContext);
  const { permissions } = user;
  const { errors, control } = form;

  return (
    <FluentProvider theme={webLightTheme}>
      <Stack tokens={{ childrenGap: 5 }}>
        <MonthDayPicker
          dueDateDay={agmStatus?.agmDueDateDay}
          dueDateMonth={agmStatus?.agmDueDateMonth}
          form={form}
          dayFormName="agmDueDateDay"
          monthFormName="agmDueDateMonth"
          label="Due Date"
          required
          disabled={!hasAccess(permissions, 'CelaAgmStatus:Update')}
        />
        <Controller
          name="agmInformation"
          control={control}
          defaultValue={agmStatus?.agmInformation || ''}
          render={({ onChange, name, value }): React.ReactElement => (
            <Field label="AGM Information" validationMessage={errors?.agmInformation?.message}>
              <Textarea
                id="agmInformation"
                name={name}
                value={value || ''}
                onChange={(e, data): void => {
                  onChange(data.value);
                }}
                disabled={!hasAccess(permissions, 'CelaAgmStatus:Update')}
                resize="vertical"
              />
            </Field>
          )}
        />
      </Stack>
    </FluentProvider>
  );
};

export default AgmStatusDueDateAndInfoForm;
